import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";

const defaultFaqs = [
  {
    question: "What is a phytosanitary certificate?",
    answer: "A phytosanitary certificate is an official document issued by a country's National Plant Protection Organization (NPPO) that certifies plants and plant products meet the importing country's health requirements. It confirms the shipment has been inspected and is free from quarantine pests and diseases, facilitating international agricultural trade."
  },
  {
    question: "Who can use Certisfy?",
    answer: "Certisfy is designed for multiple stakeholders in the export certification ecosystem: exporters and producers who apply for certificates, government inspectors who conduct inspections, National Plant Protection Organizations (NPPOs) who oversee compliance, and trade partners who verify certificate authenticity."
  },
  {
    question: "How are inspection workflows handled?",
    answer: "Inspections are managed through a queue-based system where applications are assigned to inspectors based on office location and availability. Inspectors can access their assigned inspections, record findings, attach evidence, add notes, and submit their assessment for approval. The system supports both individual and pooled inspection assignments."
  },
  {
    question: "Can export requirements differ by commodity and country?",
    answer: "Yes, Certisfy includes a configurable rules engine that allows different export requirements to be set based on commodity type and destination country. This ensures exporters are guided through the correct requirements for their specific shipment, and inspectors validate against the appropriate criteria."
  },
  {
    question: "How does certificate authenticity work?",
    answer: "Each certificate generated by Certisfy includes multiple security features: a unique barcode/QR code for verification, official watermarks, diagonal security text, and controlled issuance tracking. Trade partners can verify certificate authenticity by scanning the QR code or using the online verification portal."
  },
  {
    question: "Can we add annexures without breaking the certificate layout?",
    answer: "Yes, Certisfy's template system supports annexures for additional content that cannot fit in the main certificate. The fixed-layout template ensures the official certificate format remains consistent, while annexures provide flexibility for supplementary information like detailed product lists or additional declarations."
  },
  {
    question: "Is Certisfy suitable as a national system?",
    answer: "Absolutely. Certisfy is designed to operate at national scale with features like multi-office support, role-based access control, centralized reporting, and audit trails. It can be configured to match national regulatory frameworks and integrates with existing government systems."
  },
  {
    question: "How do we get started with Certisfy?",
    answer: "Getting started is simple: request a demo through our website, and our team will walk you through the platform's capabilities. We'll work with you to understand your specific requirements, configure the system to match your workflows, and provide training for all user groups. Implementation typically follows a phased approach to ensure smooth adoption."
  }
];

export const FAQ = (props) => {
  const faqs = props.faqs || defaultFaqs;
  const title = props.title || "Frequently Asked Questions";
  const subtitle = props.subtitle || "Everything you need to know about phytosanitary certification and Certisfy.";

  return (
    <section data-testid="faq-section" className="section-padding bg-white">
      <div className="container-custom">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl lg:text-4xl font-bold text-slate-900 mb-4">
              {title}
            </h2>
            <p className="text-lg text-slate-600">
              {subtitle}
            </p>
          </div>

          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((faq, index) => (
              <AccordionItem 
                key={index} 
                value={`item-${index}`}
                className="bg-slate-50 rounded-xl border-none px-6"
                data-testid={`faq-item-${index}`}
              >
                <AccordionTrigger className="text-left font-semibold text-slate-900 hover:text-[#1F7A3A] py-5 hover:no-underline">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-slate-600 pb-5 leading-relaxed">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};
